import styled from "styled-components"

export interface StyledListProps {
  list_color: string
  remove_border: boolean
}

export interface StyledListGroupProps {
  list_color: string
  title_exists: boolean
  remove_bullets: boolean
  remove_border: boolean
}

export const StyledList = styled.div``

export const StyledListTitle = styled.p<StyledListProps>`
  ${(props) => props.theme.mixins.bold}
  padding: 8px 0 16px 0;
  ${(props) =>
   (props.list_color === "charcoal" && !props.remove_border) &&
    `
        border-top: 3px solid ${props.theme.colors.darkGrey};
    `}
  ${(props) =>
    (props.list_color === "white" && !props.remove_border) &&
    `
        border-top: 3px solid ${props.theme.colors.white};
        color: ${props.theme.colors.white};
    `}
`

export const StyledListGroup = styled.ul<StyledListGroupProps>`
  list-style-type: none;
  margin: 0;
  padding: 0;
  ${(props) =>
    (!props.title_exists && !props.remove_border) &&
    `
    border-top: 3px solid ${
      props.list_color === "white"
        ? props.theme.colors.white
        : props.theme.colors.darkGrey
    };
    `}

  & li {
    padding: 4px 0;
    margin: 0;
    display: flex;
    ${(props) =>
      props.list_color === "charcoal" &&
      `
            border-bottom: 1px solid ${props.theme.colors.darkGrey20};

            &:nth-of-type(1){
                border-top: 1px solid ${props.theme.colors.darkGrey20};
            }
        `}
    & p {
      ${(props) => props.theme.mixins.body}
      color: ${(props) => props.theme.colors.darkGrey};
      margin: 0;
    }
    ${(props) =>
      props.list_color === "white" &&
      `
            border-bottom: 1px solid ${props.theme.colors.white20};
            color: ${props.theme.colors.white};

            & p{
                color: ${props.theme.colors.white};
            }

            &:nth-of-type(1){
                border-top: 1px solid ${props.theme.colors.white20};
            }
        `}

    ${(props) =>
      !props.remove_bullets &&
      `
            &:before{
                content: "-";
                margin-right: 8px;
            }
        `}
  }
`
